import React from "react";
import { motion } from "framer-motion";
const Forcastday = ({ date, days, weather, icon, max, min }) => {
	return (
		<>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ x: 0, opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.6 }}
			>
				<div className="forcast">
					<div>
						<h2>{date}</h2>
						<h2>{days}</h2>
					</div>

					<div>
						<img
							src={`https://openweathermap.org/img/wn/${icon}@2x.png`}
							alt="day"
						/>
					</div>
					<div>
						<h2>{weather}</h2>
					</div>
					<div style={{ display: "flex" }}>
						<div>
							<h2>{max}/</h2>
						</div>
						<div>
							<h2 style={{ color: "rgb(0,0,0,0.5)" }}>{min}</h2>
						</div>
					</div>
				</div>
			</motion.div>
		</>
	);
};

export default Forcastday;
